import React, { useContext } from 'react';
import classNames from 'classnames';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

import './rich-content-item.scss';

export interface RichContent {
    title?: string;
    photoUrl?: string;
    alt?: string;
    html?: string;
    hideItem?: boolean;
    showHalf?: boolean;
}

const RichContentItem: React.FC<RichContent> = ({
    title,
    photoUrl,
    alt,
    html,
    hideItem = true,
    showHalf = false
}) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    const isMobile = api.getDevice() === 'mobile';
    const imageSize = isMobile ? 100 : 150;

    return (
        <>
            <div
                className={classNames({
                    'rich-content-item': true,
                    'rich-content-item--hide': hideItem,
                    'rich-content-item--hide-half': showHalf,
                    'rich-content-item--mobile': isMobile
                })}
            >
                <div className="rich-content-item__image">
                    {photoUrl && (
                        <img
                            src={photoUrl}
                            alt={alt}
                            width={imageSize}
                            height={imageSize}
                            loading="lazy"
                        />
                    )}
                </div>
                <div className="rich-content-item__wrapper">
                    {title && (
                        <h3 className="title">{title}</h3>
                    )}
                    { html && (
                        <div
                            className="content"
                            dangerouslySetInnerHTML={{ __html: html }}
                        />
                    )}
                </div>
                { showHalf && (
                    <div
                        className={classNames({
                            'rich-content-item__shadow': showHalf
                        })}
                    />
                )}
            </div>
        </>
    );
};

export default RichContentItem;
